<template>
  <div class="requestBlock">
    <div class="requestTitle">
      {{
        getTranslation(
          $store,
          "Menu",
          "question_text",
          activeCombo.id,
          activeCombo.question_text
        )
      }}
    </div>
    <div class="requestFooter">
      {{
        getTranslation(
          $store,
          "Menu",
          "subtext",
          activeCombo.id,
          activeCombo.subtext
        )
      }}
    </div>
    <div class="requestActions">
      <div class="btn denyBtn" @click="addBasket">
        {{ $t("combo.btn.deny_combo") }}
      </div>
      <div class="btn requestBtn" @click="selectComboAnimation">
        {{ $t("combo.btn.get_combo") }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  productToBasketItem,
  createNewObject,
  findSameBasketItem,
  combineProductsToMenu,
  addProductToBasket
} from "@/utils/products";

import {
  generate_random_string,
  transitionAnimation,
  opacityAnimation,
  getTranslation,
  getPotentialMenus,
  getTranslatedMenuName
} from "@/utils/helpers";

import { cloneDeep } from "lodash";

export default {
  computed: {
    ...mapGetters({
      activeCombo: "ACTIVE_COMBO",
      basket: "BASKET",
      products: "PRODUCTS",
      menus: "MENUS"
    })
  },
  methods: {
    getTranslation,
    addBasket() {
      const basketItem = this.activeCombo.components[0].selected;
      const product = this.products.find(elem => elem.id === basketItem.id);
      if (product && product.menus && product.menus.length > 1) {
        const potential_menus = getPotentialMenus(
          this.menus,
          product.menus,
          false
        );
        if (potential_menus.length > 1) {
          const menu = cloneDeep(potential_menus[1]);
          const menuItem = productToBasketItem(product);

          if (this.activeCombo.components[0].selected.selectedSize) {
            menuItem.selectedSize = createNewObject(
              this.activeCombo.components[0].selected.selectedSize
            );
          }
          if (this.activeCombo.components[0].selected.selectedExtras) {
            menuItem.selectedExtras = createNewObject(
              this.activeCombo.components[0].selected.selectedExtras
            );
          }
          menu.components[0].selected = menuItem;
          menu.name = getTranslatedMenuName(this.$store, menu);
          menu.needAsk = true;
          menu.selectedCombo = true;
          menu.uid = generate_random_string(16);

          this.setActiveCombo(menu);
          this.setActiveComponent(menu);
          this.selectCombo();
          return;
        }
      }
      if (basketItem) {
        let newBasket = addProductToBasket(basketItem, this.basket);
        newBasket = combineProductsToMenu(this.menus, newBasket);
        this.setBasket(newBasket);
        this.logAudit({
          category: "CART",
          event: "ADD_PRODUCT",
          data: basketItem
        });
      }
      if (this.basket && this.basket.length >= 1) {
        this.logRouter({ name: "order", router: this.$router });
      } else {
        this.logRouter({ name: "menu", router: this.$router });
      }
    },
    ...mapMutations({
      setCurrentCategory: "SET_CURRENT_CATEGORY",
      setBasket: "SET_BASKET",
      setActiveCombo: "SET_ACTIVE_COMBO"
    }),
    ...mapActions({ logRouter: "LOG_ROUTER", logAudit: "LOG_AUDIT" }),
    selectComboAnimation() {
      const data = {
        start: {
          height: 1153,
          width: 1199,
          top: -466,
          left: -59
        },
        end: {
          height: 919,
          width: 955,
          left: 63,
          top: -420
        },
        move: {
          height: -10,
          width: -10,
          left: 5,
          top: 20
        },
        condition: {
          steps: 250,
          step: 10,
          speed: 10,
          zIndex: 100
        }
      };
      const opacityConfig = {
        from: 1,
        to: 0,
        step: -0.1
      };
      opacityAnimation("requestImgBlock", opacityConfig);
      transitionAnimation("yellowCircleCombo", data, this.selectCombo);
    },
    setActiveComponent(menu) {
      if (menu.components[1]) {
        let payload = { id: menu.components[1].id };
        this.$emit("changeComponent", payload);
      }
    },
    selectCombo() {
      const newActive = {
        ...this.activeCombo,
        selectedCombo: true,
        needAsk: false
      };
      this.logAudit({
        category: "COMBO",
        event: "CREATED",
        data: newActive
      });
      this.setActiveCombo(newActive);
    }
  }
};
</script>
<style lang="scss" scoped>
.requestBlock {
  height: 190px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin-top: 350px;
}
.requestTitle {
  font-family: var(--component_combo_requestCombo_requestTitle_font-family);
  letter-spacing: 0;
  color: var(--component_combo_requestCombo_requestTitle_color);
  text-transform: var(
    --component_combo_requestCombo_requestTitle_text-transform
  );
  font-size: var(--component_combo_requestCombo_requestTitle_font-size);
}
.requestFooter {
  font-family: var(--component_combo_requestCombo_requestFooter_font-family);
  font-size: var(--component_combo_requestCombo_requestFooter_font-size);
  color: var(--component_combo_requestCombo_requestFooter_color);
}
.btn {
  font-family: var(--component_combo_requestCombo_btn_font-family);
  font-size: var(--component_combo_requestCombo_btn_font-size);
  border-radius: var(--component_combo_requestCombo_btn_border-radius);
  display: flex;
  justify-content: center;
  align-items: center;
}

.denyBtn {
  color: var(--component_combo_requestCombo_denyBtn_color);
  border: var(--component_combo_requestCombo_denyBtn_border);
  background: var(--component_combo_requestCombo_denyBtn_background);
  width: 210px;
  height: 70px;
}

.requestBtn {
  color: var(--component_combo_requestCombo_requestBtn_color);
  border: var(--component_combo_requestCombo_requestBtn_border);
  background: var(--component_combo_requestCombo_requestBtn_background);
  width: 337px;
  height: 70px;
  letter-spacing: 1px;
}

.requestActions {
  display: flex;
  width: 615px;
  justify-content: space-around;
}
</style>
